import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
// removed: import { DatatablePagerComponent as SuperDataTablePagerComponent } from '@siemens/ngx-datatable';

@Component({
  selector: 'app-datatable-pager',
  template: `
    <ul class="pager">
      <li [class.disabled]="!canPrevious()">
        <a href="javascript:void(0)" (click)="selectPage(1)">
          <i class="{{pagerPreviousIcon}}"></i>
        </a>
      </li>
      <li [class.disabled]="!canPrevious()">
        <a href="javascript:void(0)" (click)="prevPage()">
          <i class="{{pagerLeftArrowIcon}}"></i>
        </a>
      </li>
      @for (pg of pages; track pg) {
        <li class="pages" [class.active]="pg.number === page">
          <a href="javascript:void(0)" (click)="selectPage(pg.number)">
            {{pg.text}}
          </a>
        </li>
      }
      <li [class.disabled]="!canNext()">
        <a href="javascript:void(0)" (click)="nextPage()">
          <i class="{{pagerRightArrowIcon}}"></i>
        </a>
      </li>
      <li [class.disabled]="!canNext()">
        <a href="javascript:void(0)" (click)="selectPage(totalPages)">
          <i class="{{pagerNextIcon}}"></i>
        </a>
      </li>
    </ul>
    `,
  styles: [`
      :host { display: block; }
      ul.pager {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 0;
        padding: 0;
        list-style: none;
      }
      ul.pager li {
        display: inline-flex;
        margin: 0 2px;
      }
      ul.pager li a {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 28px;
        height: 28px;
        padding: 0 6px;
        border-radius: 4px;
        color: inherit;
        text-decoration: none;
        cursor: pointer;
      }
      ul.pager li.pages.active a {
        background: #5b4bdb;   /* match your theme accent */
        color: #fff;
      }
      ul.pager li.disabled a {
        opacity: 0.4;
        pointer-events: none;
      }
      ul.pager li a:hover:not(.disabled) {
        background: rgba(0,0,0,0.06);
      }
    `],
  host: {
    class: 'datatable-pager'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DataTablePagerComponent {

  _count = 0;
  _page = 1;
  _size = 0;
  pages: any;

  @Input() pagerLeftArrowIcon: string = 'datatable-icon-left';
  @Input() pagerRightArrowIcon: string = 'datatable-icon-right';
  @Input() pagerPreviousIcon: string = 'datatable-icon-prev';
  @Input() pagerNextIcon: string = 'datatable-icon-skip';

  @Input()
  set size(val: number) {
    this._size = val;
    this.pages = this.calcPages();
  }
  get size(): number {
    return this._size;
  }

  @Input()
  set count(val: number) {
    this._count = val;
    this.pages = this.calcPages();
  }
  get count(): number {
    return this._count;
  }

  @Input()
  set page(val: number) {
    this._page = val;
    this.pages = this.calcPages();
  }
  get page(): number {
    return this._page;
  }

  get totalPages(): number {
    const count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
    return Math.max(count || 0, 1);
  }

  @Output() change: EventEmitter<any> = new EventEmitter();

  _visiblePagesCount: number = 3;

  @Input()
  set visiblePagesCount(val: number) {
    this._visiblePagesCount = val;
    this.pages = this.calcPages();
  }
  get visiblePagesCount(): number {
    return this._visiblePagesCount;
  }

  canPrevious(): boolean {
    return this.page > 1;
  }

  canNext(): boolean {
    return this.page < this.totalPages;
  }

  prevPage(): void {
    this.selectPage(this.page - 1);
  }

  nextPage(): void {
    this.selectPage(this.page + 1);
  }

  selectPage(page: number): void {
    if (page > 0 && page <= this.totalPages && page !== this.page) {
      this.page = page;
      this.change.emit({ page });
    }
  }

  calcPages(page?: number): any[] {
    const pages = [];
    let startPage = 1;
    let endPage = this.totalPages;
    const maxSize = this.visiblePagesCount;
    const isMaxSized = maxSize < this.totalPages;
    page = page || this.page;
    if (isMaxSized) {
      startPage = page - Math.floor(maxSize / 2);
      endPage = page + Math.floor(maxSize / 2);
      if (startPage < 1) {
        startPage = 1;
        endPage = Math.min(startPage + maxSize - 1, this.totalPages);
      } else if (endPage > this.totalPages) {
        startPage = Math.max(this.totalPages - maxSize + 1, 1);
        endPage = this.totalPages;
      }
    }
    for (let num = startPage; num <= endPage; num++) {
      pages.push({ number: num, text: <string><any>num });
    }
    return pages;
  }
}
